module.exports = __webpack_public_path__ + "img/16_26.1c95cc8d.png";